export enum COMPANY_LIST_COLUMNS_VALUES {
  COMPANY_NAME = "companyName",
  BUSINESS_NAME = "businessName",
  BUSINESS_SECTOR = "businessSector",
  CUIT = "cuit",
  UPDATED_AT = "updatedAt",
  HAS_AN_INTERNSHIP_AGREEMENT = "hasAnInternshipAgreement",
  STATE = "state",
  ACTIONS = "actions"
}

export const COMPANY_LIST_COLUMNS = [
  COMPANY_LIST_COLUMNS_VALUES.COMPANY_NAME,
  COMPANY_LIST_COLUMNS_VALUES.BUSINESS_NAME,
  COMPANY_LIST_COLUMNS_VALUES.BUSINESS_SECTOR,
  COMPANY_LIST_COLUMNS_VALUES.CUIT,
  COMPANY_LIST_COLUMNS_VALUES.UPDATED_AT,
  COMPANY_LIST_COLUMNS_VALUES.HAS_AN_INTERNSHIP_AGREEMENT,
  COMPANY_LIST_COLUMNS_VALUES.STATE,
  COMPANY_LIST_COLUMNS_VALUES.ACTIONS
];
